import React, { useEffect, useState } from 'react';
import MediaQuery, { useMediaQuery } from 'react-responsive';

// DS
import {
  Row,
  VertBreadcrumb,
  VertContainer,
  VertIcon,
} from '@vertem-core/vertice-ds';

// COMPONENTS
import { SearchSidebar, SearchTopbar } from 'components/SearchSidebar';
import Pagination from 'components/Pagination/Pagination';
import SearchFilter from 'components/SearchSidebar/SearchFilters';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RightOutlined } from '@ant-design/icons';
import CategoryItems from '../CategoryPage/CategoryItems';
import CategoryWrapper from '../CategoryPage/CategoryWrapper';
import CreateFiltersParams from '../../Utils/createFiltersParams';
import usePipeContext from '../../Services/Providers/PipeProvider/usePipeContext';
import CreateSearchHash from '../../Utils/createSearchHash';
import FormatProductsItems from '../../Utils/formatProductsItems';
import CategoryPagePlaceholder from '../CategoryPage/CategoryPagePlaceholder';
import SelectOrderBy from '../../components/SelectOrderBy/SelectOrderBy';
import { useStoresSearchPage } from './StoresSearchProvider';
import { isEmpty } from 'lodash';

const breadcrumbMock = [
  {
    title: 'Início',
    path: '/',
  },
  {
    title: 'Loja',
    path: '',
  },
];
// CATEGORY PAGE
const StoresSearchPage = () => {
  const [currentPage, setCurrentPage] = useState(null);
  const Search = useSelector(({ Search: data }) => data);
  const Navigate = useNavigate();
  const {
    filter: filterObject,
    setFilter,
    title,
    setTitle,
    filterString,
  } = useStoresSearchPage();
  const { callApiForce } = usePipeContext();
  const [searchSidebarVisible, setSearchSidebarVisible] = useState(false);
  const { id: storeId, pagenumber, filter: filterParam } = useParams();
  const isLargeScreen = useMediaQuery({ minWidth: 769 });

  /* Vars */
  const wrapperGutterValue = isLargeScreen ? 20 : 0;

  const handleSetFilter = (fParam) => {
    setFilter(
      CreateFiltersParams(
        {
          vendors: storeId,
          pageIndex: parseInt(pagenumber, 10) - 1,
        },
        fParam
      ),
      fParam
    );
    setCurrentPage(pagenumber);
  };

  useEffect(() => {
    if (
      storeId &&
      pagenumber &&
      (!filterObject ||
        filterObject.vendors !== storeId ||
        (filterParam && filterParam !== filterString) ||
        (!filterParam && filterString && filterString !== 'e30=') ||
        pagenumber !== currentPage)
    ) {
      let f = filterParam || 'e30=';
      if (filterString && !filterParam) f = false;
      handleSetFilter(f);
    }
  }, [
    storeId,
    pagenumber,
    filterParam,
    setFilter,
    filterObject,
    filterString,
    currentPage,
  ]);

  useEffect(() => {
    if (filterObject && callApiForce && filterObject.vendors == storeId) {
      callApiForce(
        {
          symbol: 'FETCH_SEARCH',
          alias: null,
          payload: { filters: { ...filterObject } },
        },
        new Date().getTime()
      );
    }
  }, [filterObject, callApiForce]);

  useEffect(() => {
    if (
      Search &&
      !Search.isLoading &&
      Search.data &&
      Search.data.vendors &&
      Search.data.vendors.length &&
      Search.data.vendors[0].name !== title
    ) {
      setTitle(Search.data.vendors[0].name);
      return;
    }

    if (isEmpty(Search.data?.vendors)) {
      setTitle('');
    }
  }, [Search, title, Search.data?.vendors]);

  return (
    <>
      <VertContainer
        className="vert-container-page"
        spacingX="regular"
        spacingY="regular"
      >
        <VertBreadcrumb hasBackButton={true}
          separator={<VertIcon component={RightOutlined} />}
          items={breadcrumbMock}
        />
      </VertContainer>
      {(() => {
        if (!Search || Search.isLoading) return <CategoryPagePlaceholder />;
        return (
          <VertContainer
            className="vert-container-page"
            spacingX="regular"
            spacingY="regular"
          >
            <MediaQuery maxWidth={768}>
              <SelectOrderBy
                searchSidebarVisible={searchSidebarVisible}
                toggleSearchSidebar={setSearchSidebarVisible}
                valueSort={
                  (filterObject &&
                    filterObject.sort !== 'SCORE' &&
                    filterObject.sort) ||
                  ''
                }
                onChange={(e) => {
                  if (e !== 'SCORE') {
                    const searchString = CreateSearchHash(filterObject, {
                      sort: e,
                    });
                    Navigate(`/store/${storeId}/1/filter/${searchString}`);
                  } else {
                    const searchString = CreateSearchHash(filterObject, {});
                    handleSetFilter(null);
                    setTimeout(() => {
                      if (searchString) {
                        Navigate(`/store/${storeId}/1/filter/${searchString}`);
                      } else {
                        Navigate(`/store/${storeId}/1`);
                      }
                    }, 500);
                  }
                }}
              />
            </MediaQuery>
            <SearchTopbar
              title={title}
              titleVendor={title}
              value={
                (filterObject &&
                  filterObject.sort !== 'SCORE' &&
                  filterObject.sort) ||
                ''
              }
              onChange={(e) => {
                if (e !== 'SCORE') {
                  const searchString = CreateSearchHash(filterObject, {
                    sort: e,
                  });
                  Navigate(`/store/${storeId}/1/filter/${searchString}`);
                } else {
                  const searchString = CreateSearchHash(filterObject, {});
                  handleSetFilter(null);
                  setTimeout(() => {
                    if (searchString) {
                      Navigate(`/store/${storeId}/1/filter/${searchString}`);
                    } else {
                      Navigate(`/store/${storeId}/1`);
                    }
                  }, 500);
                }
              }}
            />
            <Row gutter={wrapperGutterValue}>
              <SearchSidebar
                searchSidebarVisible={searchSidebarVisible}
                toggleSearchSidebar={setSearchSidebarVisible}
              >
                <MediaQuery maxWidth={768}>
                  <SearchFilter
                    hideStores
                    filters={filterObject}
                    filterParams={filterParam}
                    clearFilters={() => {
                      Navigate(`/store/${storeId}/1`);
                    }}
                    onSubmit={(hash) => {
                      if (hash) {
                        Navigate(`/store/${storeId}/1/filter/${hash}`);
                      } else {
                        Navigate(`/store/${storeId}/1`);
                      }
                    }}
                  />
                </MediaQuery>
                <MediaQuery minWidth={769}>
                  {(() => {
                    if (!Search || Search.isLoading) {
                      return null;
                    }
                    return (
                      <SearchFilter
                        hideStores
                        className="padding-x-small padding-y-small"
                        filters={filterObject}
                        filterParams={filterParam}
                        clearFilters={() => {
                          Navigate(`/store/${storeId}/1`);
                        }}
                        onSubmit={(hash) => {
                          if (hash) {
                            Navigate(`/store/${storeId}/1/filter/${hash}`);
                          } else {
                            Navigate(`/store/${storeId}/1`);
                          }
                        }}
                      />
                    );
                  })()}
                </MediaQuery>
              </SearchSidebar>
              <CategoryWrapper>
                {(() => {
                  if (Search.isLoading || !Search.data) return null;
                  return (
                    <CategoryItems
                      items={FormatProductsItems(Search.data.products) || []}
                    />
                  );
                })()}
              </CategoryWrapper>
            </Row>
            {(() => {
              if (Search.isLoading || !Search.data) return null;
              return (
                <Pagination
                  current={parseInt(pagenumber, 10)}
                  total={Search.data.totalRowCount}
                  pageSize={12}
                  callback={(page) => {
                    if (filterParam) {
                      Navigate(
                        `/store/${storeId}/${page}/filter/${filterParam}`
                      );
                    } else {
                      Navigate(`/store/${storeId}/${page}`);
                    }
                  }}
                />
              );
            })()}
          </VertContainer>
        );
      })()}
    </>
  );
};

export default StoresSearchPage;
